import _ from 'lodash'

import { Creators as AlertActions } from '../appRedux/ducks/alert'
import { Creators as LoadingActions } from '../appRedux/ducks/loading'
import store, { history } from '../appRedux/store'
import * as api from '../services/api'

export function getErrorRequestMessage(error) {
  const errorCode = _.get(error, 'data.message')
  if (String(errorCode) === 'token-expired') {
    window.localStorage.clear()
    history.replace('/login?expired=true')
    window.location.href = '/login?expired=true'
    const response = {
      message: 'Token expirou'
    }
    return response
  }

  if (_.get(error, 'data.message')) {
    const description = error.data.description ? `: ${error.data.description}` : ''
    const errorDescription = `${error.data.message}${description}`
    return {
      message: errorDescription,
      status: undefined
    }
  }

  const response = {
    message: 'Ocorreu um erro desconhecido',
    status: undefined
  }
  return response
}

const closeLoading = () => store.dispatch(LoadingActions.closeLoading())

export async function request(
  functionRequest,
  skipLoading = false,
  skipError = false,
  skipCloseLoading = false,
  loadingMessage = ''
) {
  try {
    if (!skipLoading || skipLoading !== true) {
      store.dispatch(LoadingActions.openLoading(loadingMessage))
    }

    const data = await functionRequest

    if (!skipCloseLoading) {
      closeLoading()
    }

    return data
  } catch (error) {
    closeLoading()
    if (!skipError) {
      const errorMessage = getErrorRequestMessage(error.response)
      store.dispatch(AlertActions.openAlert(errorMessage))
    }

    throw error.response
  }
}

export { api }
